import React from 'react';
import { Navbar, Nav, NavDropdown, Button } from 'react-bootstrap';
import { FaDollarSign, FaCog, FaSignOutAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import Marquee from './Marquee'; // Import the Marquee component

const NavbarComponent = ({ userDetails, setShowLogoutModal, isMobile, toggleSidebar }) => {
  return (
    <>
       {/* Marquee for the news section */}
       <Marquee text="Exciting new investment plans are coming soon! We're working every day to bring you even greater services. Stay tuned!" />


      <Navbar bg="dark" variant="dark" expand="lg">
        <Navbar.Brand href="#home" className="mp-2 p-3">My Dashboard</Navbar.Brand>

        {/* Hamburger button only visible on mobile */}
        <div className="d-md-none">
          {isMobile && (
            <Button
              variant="outline-light"
              className="d-lg-none"  // Hide button on large screens
              onClick={toggleSidebar}
            >
              ☰ More
            </Button>
          )}
        </div>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto">
            <Nav.Link>
              <strong>
                Bal <FaDollarSign className="mr-2" />
                {userDetails ? userDetails.balance : 'Loading...'}
              </strong>
            </Nav.Link>

            <NavDropdown title="Profile" id="basic-nav-dropdown">
              <NavDropdown.Item onClick={() => setShowLogoutModal(true)}>
                <FaSignOutAlt className="mr-2" />
                Logout
              </NavDropdown.Item>
            </NavDropdown>

            <Nav.Link as={Link} to="/dashboard/settings">
              <FaCog className="mr-2" />
              Settings
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
};

export default NavbarComponent;
